import React, { useEffect, useRef, useState } from 'react';
import EmissionTrendGraph from './EmissionTrendGraph';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import useAxiosProtect from '../../../../hooks/useAxiosProtect';
// import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import useAuth from '../../../../hooks/useAuth';
import carbonOne from '../../../../media/carbonone_logo.webp'
import { Carousel } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';

// import { 
//     scope12EmissionsTest, 
//     scope12IntensityEmissionsTest, 
//     scope12IntensityReductionsTest, 
//     scope12ReductionsTest, 
//     financialSavingsTest, 
//     financialSavingsProdTest, 
//     // scope123Emissions, 
//     // scope123Reductions, 
//     // financialSavingsScope123, 
//     // financialSavingsScope123Intensity, 
//     // financialSavingsScope123Reductions, 
//     // scope123Intensity,
//     //  scope123IntensityReductions 
// } from './testData';
import TargetInfoModal from './TargetInfoModal';

// Legacy six-card/selectable-target container retained for easy reversion.
// const EmissionTrends = props => {
const LegacyEmissionTrends = props => {
    const [showScope3, setShowScope3] = useState(false);

    var init = useRef(true);
    const [isLoading, setIsLoading] = useState(true);
    const sites_hidden = "hidden";
    const [scope12Emissions, setScope12Emissions] = useState([]);
    const [scope12Reductions, setScope12Reductions] = useState([]);
    const [scope12IntensityEmissions, setScope12IntensityEmissions] = useState([]);
    const [scope12IntensityReductions, setScope12IntensityReductions] = useState([]);
    const [financialSavings, setFinancialSavings] = useState([]);
    const [financialSavingsNormalized, setFinancialSavingsNormalized] = useState([]);

    const [siteNames, setSiteNames] = useState([]);
    const [selectableSites, setSelectableSites] = useState([]);
    const [siteLookup, setSiteLookup] = useState({});

    const [activeTarget, setActiveTarget] = useState(null);
    const [selectableTargets, setSelectableTargets] = useState([]);
    var selectedTarget = useRef(null);
    const [targetInfoModalOpen, setTargetInfoModalOpen] = useState(false);

    const axiosProtect = useAxiosProtect();
    const {auth, authContext} = useAuth();

    const [errorMessage, setErrorMessage] = useState('');
    const [actualPct, setActualPct] = useState(0);

    const updatePct = dataSet => {
        let currentYear = new Date().getFullYear();
        let counter = 0;

        for(let i = 0;i<dataSet.length;++i){
            if(dataSet[i].year <= currentYear) ++counter;
            else{
                setActualPct(100 * counter / dataSet.length);
                return;
            }
        }

        setActualPct(100);
    }

    useEffect(() => {
        if(!init.current) return;

        let siteQueryURL = props.isAdminView === true ? 
            `/auth/query/list-org-sites=from-site-id?siteID=${window.location.href.split('/').slice(-1)[0]}` :
            `/auth/query/list-client-site-access?uid=${auth?.id}`;

        axiosProtect.get(siteQueryURL).then(response => {
            console.log(response.data.sites)
            let siteNameArr = [];
            let siteLookupObj = {};
            for(let i = 0;i<response.data.sites.length;++i){
                siteNameArr.push(response.data.sites[i].name)
                siteLookupObj[response.data.sites[i].name] = response.data.sites[i].id
            }

            setSiteNames(siteNameArr);
            setSelectableSites(siteNameArr);
            setSiteLookup(siteLookupObj);

            axiosProtect.get(`/tg/targets/emissions-graphs?sites=${Object.values(siteLookupObj).join(',')}`).then(response => {
                setScope12Emissions(response.data.graphData.scope12Emissions);
                setScope12Reductions(response.data.graphData.scope12Reductions);
                setScope12IntensityEmissions(response.data.graphData.scope12EmissionsNormalized);
                setScope12IntensityReductions(response.data.graphData.scope12ReductionsNormalized)
                setFinancialSavings(response.data.graphData.financialSavings);
                setFinancialSavingsNormalized(response.data.graphData.financialSavingsNormalized);

                updatePct(response.data.graphData.scope12Emissions);

                setActiveTarget(response.data.activeTarget);
                setSelectableTargets([...response.data.selectableTargets]);

                setIsLoading(false);
                init.current = false;

            }).catch(err => {
                setIsLoading(false); 
                setErrorMessage(err.response.data);
                init.current = false;
            });
        }).catch(err => {setErrorMessage(err.response.data);});
    }, []);

    useEffect(() => {
        if(!isLoading || init.current) return;

        let siteIDs = [];

        for(let i = 0;i<siteNames.length;++i){
            siteIDs.push(siteLookup[siteNames[i]]);
        }

        console.log(siteIDs.join(','))

        let url = `/tg/targets/emissions-graphs?sites=${siteIDs.join(',')}${selectedTarget.current != null ? `&targetID=${selectedTarget.current.id}` : ''}`;
        selectedTarget.current = null;

        axiosProtect.get(url).then(response => {
            setScope12Emissions(response.data.graphData.scope12Emissions);
            setScope12Reductions(response.data.graphData.scope12Reductions);
            setScope12IntensityEmissions(response.data.graphData.scope12EmissionsNormalized);
            setScope12IntensityReductions(response.data.graphData.scope12ReductionsNormalized)
            setFinancialSavings(response.data.graphData.financialSavings);
            setFinancialSavingsNormalized(response.data.graphData.financialSavingsNormalized);

            updatePct(response.data.graphData.scope12Emissions);

            setActiveTarget(response.data.activeTarget);
            setSelectableTargets([...response.data.selectableTargets]);

            setIsLoading(false);
            setErrorMessage('');
            init.current = false;

        }).catch(err => {
            setScope12Emissions([]);
            setScope12Reductions([]);
            setScope12IntensityEmissions([]);
            setScope12IntensityReductions([])
            setFinancialSavings([]);
            setFinancialSavingsNormalized([]);

            setActiveTarget(null);
            setSelectableTargets([]);

            setIsLoading(false); 
            init.current = false;
            setErrorMessage(err.response.data);
        });
    }, [isLoading]);

    const handleSiteSelection = e => {
        const {target: {value}} = e;

        // if(value.length === 0) return;
        setIsLoading(true);

        setSiteNames(typeof value === 'string' ? value.split(',') : value);
    }

    const handleTargetSelection = e => {
        for(let i = 0;i<selectableTargets.length;++i){
            if(selectableTargets[i].id === e.target.value){
                setActiveTarget(selectableTargets[i]);
                selectedTarget.current = selectableTargets[i];
                setIsLoading(true);
                break;
            }
        }
    }

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            },
        },
    };

    const closeModal = () => {
        setTargetInfoModalOpen(false);
    }
    const renderCard = (title, subTitle, data, isFinancial, yAxisLabel) => (
    <div
        style={{
            flex:'50',
            height:'40vh',
            backgroundColor:'white',
            borderRadius:'1%',
            boxShadow:'2px 6px 12px rgb(164, 164, 164)',
            padding:'0.5%'
        }}
    >
        {isLoading ? (
            <Box sx={{ display: 'flex' }}>
                <CircularProgress style={{margin:'auto', marginTop:'25%'}}/>
            </Box>
        ) : (
            <EmissionTrendGraph
                title={title}
                subTitle={subTitle}
                data={data}
                pct={actualPct}
                isFinancial={isFinancial}
                yAxisLabel={yAxisLabel}
                showScope3={showScope3}
            />
        )}
    </div>
);


    return(
        <>
            {targetInfoModalOpen && <TargetInfoModal showModal={targetInfoModalOpen} closeModal={closeModal} target={activeTarget}/>}

            <div className="w-full">
                {/* <FormGroup style={{paddingLeft:'0.5%'}}>
                    <FormControlLabel style={{width:'fit-content'}} control={
                            <Switch style={{color:'rgb(8,114,182)'}} checked={showScope3} onClick={() => setShowScope3(!showScope3)}/>
                        } label={<p style={{margin:'0', fontSize:'95%'}}>Include Scope 3 emissions</p>} />
                </FormGroup> */}

                <div style={{display:'flex', flexDirection: props.isMobile ? 'column' : 'row'}}>
                    <div style={{flex:'1', display: 'flex', alignItems: 'center'}}>
                        {
                            errorMessage !== '' ?
                            <Alert severity="error" variant='filled' sx={{ alignItems: 'center', flex:'2' }}>{errorMessage}</Alert>
                            :
                            (errorMessage === '' && activeTarget != null && !isLoading) ?
                            <IconButton style={{borderRadius:'2%', backgroundColor:'rgba(8,114,182, 0.1)', display: 'inline-flex', alignItems: 'center', margin: props.isMobile ? 'auto' : '0'}} color="info">
                                <p style={{margin:'1% 0', fontSize:'1rem'}} onClick={() => {
                                    setTargetInfoModalOpen(true);
                                }}>See active target specs</p>
                            </IconButton>
                            :
                            <></>
                        }
                    </div>

                    <div className="field-spacer-sm"></div>
                    
                    <div style={{flex:'1', textAlign: props.isMobile ? 'center' : 'right'}}> 
                        <IconButton className="et-carbon-one-icon-btn">
                            <a
                                href="https://cloud.carbon-one.ca/company-dashboard" target="_blank" className="et-carbon-one-link"><img
                                src={carbonOne}
                                alt="Carbon One"
                                className="et-carbon-one-logo"
                            /></a>
                        </IconButton>    
                    </div>
                </div>

                <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
                    <div style={{display:'flex', flexDirection:'row', flex:'2', width:'100%'}}>
                        <FormControl sx={{ m: 1, flex: 2 }}>
                            <InputLabel id="demo-multiple-checkbox-label">Sites</InputLabel>
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={siteNames}
                                onChange={handleSiteSelection}
                                input={<OutlinedInput label="Sites" />}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={MenuProps}
                            >
                            {selectableSites.map(site => (
                                <MenuItem key={site} value={site}>
                                    <Checkbox checked={siteNames.includes(site)} />
                                    <ListItemText primary={site} />
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>

                        {
                            !props.isMobile &&
                            <Tooltip 
                                title='Selected sites will be included in the aggregated trends below. Note that selecting more than one site at once will allow you to only compare emissions to organization-wide targets. To access site-specific targets, select a single site at a time.'
                                slotProps={{popper: {sx: { zIndex: 1000000 }}}}
                            >
                                <IconButton style={{display: 'inline-flex', alignItems: 'center', marginLeft:'1%'}}>
                                    <HelpCenterIcon/>
                                </IconButton>
                            </Tooltip>
                        }
                    </div>
                    
                    <div style={{flex:'0.5'}}></div>

                    <FormControl sx={{ m: 1, flex: 2 }}>
                        <InputLabel id="demo-multiple-checkbox-label">Target</InputLabel>
                        <Select
                            labelId="demo-multiple-checkbox-label"
                            id="demo-multiple-checkbox"
                            // multiple
                            value={activeTarget == null ? '' : activeTarget.id}
                            onChange={handleTargetSelection}
                            input={<OutlinedInput label="Target" />}
                            renderValue={() => `${activeTarget?.title} ${activeTarget ? `(baseline ${activeTarget.baseline_year}; ${activeTarget.is_org_wide ? 'org-level': 'site-specfic'})` : ''}`}
                        >
                        {selectableTargets.map(target => (
                            <MenuItem key={target.id} value={target.id}>
                                <ListItemText primary={`${target.title} (baseline ${target.baseline_year}; ${target.is_org_wide ? 'org-level': 'site-specfic'})`} />
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                </div>

                {!isMobile ? (
                    <>

                    <div className="et-utility-row">
                        {renderCard(`Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} GHG Emissions`, '', scope12Emissions, false, 'tonnes CO2eq/year')}

                        <div className="field-spacer-sm"></div>

                        {renderCard(`Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} GHG Emission Reductions`, '', scope12Reductions, false, 'tonnes CO2eq/year')}

                        <div className="field-spacer-sm"></div>

                        {renderCard(`Financial Savings (Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} Projects)`, '', financialSavings, true, '$/year')}
                    </div>

                    <div className="et-utility-row">
                        {renderCard(`Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} GHG Intensity`, '(Normalized by production)', scope12IntensityEmissions, false, 'tonnes CO2eq/tonne product')}

                        <div className="field-spacer-sm"></div>

                        {renderCard(`Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} GHG Intensity Reductions`, '(Normalized by production)', scope12IntensityReductions, false, 'tonnes CO2eq/tonne product')}

                        <div className="field-spacer-sm"></div>

                        {renderCard(`Financial Savings (Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} Projects)`, '(Normalized by production)', financialSavingsNormalized, true, '$/tonne product')}
                    </div>
                    </>
                ) : (
                    /* MOBILE */
                    <div style={{padding:'0.5%'}}>
                        <Carousel interval={null}>
                            <Carousel.Item>
                                {renderCard(`Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} GHG Emissions`, '', scope12Emissions, false, 'tonnes CO2eq/year')}
                            </Carousel.Item>

                            <Carousel.Item>
                                {renderCard(`Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} GHG Emission Reductions`, '', scope12Reductions, false, 'tonnes CO2eq/year')}
                            </Carousel.Item>

                            <Carousel.Item>
                                {renderCard(`Financial Savings (Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} Projects)`, '', financialSavings, true, '$/year')}
                            </Carousel.Item>

                            <Carousel.Item>
                                {renderCard(`Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} GHG Intensity`, '(Normalized by production)', scope12IntensityEmissions, false, 'tonnes CO2eq/tonne product')}
                            </Carousel.Item>

                            <Carousel.Item>
                                {renderCard(`Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} GHG Intensity Reductions`, '(Normalized by production)', scope12IntensityReductions, false, 'tonnes CO2eq/tonne product')}
                            </Carousel.Item>

                            <Carousel.Item>
                                {renderCard(`Financial Savings (Scope ${showScope3 ? '1, 2 & 3' : '1 & 2'} Projects)`, '(Normalized by production)', financialSavingsNormalized, true, '$/tonne product')}
                            </Carousel.Item>
                        </Carousel>
                        <div style={{ textAlign: 'center', marginBottom: '6px' }}>
                            <div style={{ fontSize: '0.85rem', color: 'grey' }}>
                                ← Swipe to see other Glidepaths →
                            </div>
                        </div>
                    </div>
                    
                )}
            </div>

            {/* <div style={{display:'flex', flexDirection:'row'}}>
                <div style={{flex:'50', height:'42vh', backgroundColor:'white', padding:'1vh 1vw', borderRadius:'1%', boxShadow:"2px 6px 12px rgb(164, 164, 164)"}}>
                    <h4>Carbon Reduction Progress</h4>
                    <TargetEmissions parameter='Water' value={1827 * 3} units='m3' graphColor='rgb(8,114,182)' graphId='waterPv' pctChange={4} events={0}graphColor2='rgb(213,43,0)'/>
                </div>

                <div style={{flex:'1'}}></div>

                <div style={{flex:'40', height:'42vh', backgroundColor:'white', padding:'1vh 1vw', borderRadius:'1%', boxShadow:"2px 6px 12px rgb(164, 164, 164)"}}>
                    <h4>Emissions by Component</h4>
                    <UtilityEmissions/>
                </div>
            </div>

            <Divider style={{margin:'1.75vh 0 1.75vh 0'}}/>

            <div style={{display:'flex', flexWrap:'wrap', width:'100%'}}>
                <div style={{height:'42vh', width:'49.25%'}}>
                    <OppEmissions/>
                </div>

                <div style={{width:'1.5%'}}></div>

                <div style={{height:'42vh', width:'49.25%'}}>
                    <OppSavings/>
                </div>
            </div> */}
        </>
    );
}

const PARAMETER_OPTIONS = [
    {value: 'emissions', label: 'Emissions', title: 'Scope 1 & 2 GHG Emissions', units: 'tonnes CO2eq/year'},
    {value: 'reductions', label: 'Emissions reductions', title: 'Scope 1 & 2 GHG Emission Reductions', units: 'tonnes CO2eq/year'},
    {value: 'financialSavings', label: 'Financial savings', title: 'Financial Savings (Scope 1 & 2 Projects)', units: '$/year'}
];

const ConsolidatedEmissionTrends = props => {
    const axiosProtect = useAxiosProtect();
    const {auth} = useAuth();
    const [selectableSites, setSelectableSites] = useState([]);
    const [selectedSiteNames, setSelectedSiteNames] = useState([]);
    const [parameter, setParameter] = useState('emissions');
    const [graphData, setGraphData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const siteQueryURL = props.isAdminView === true
            ? `/auth/query/list-org-sites=from-site-id?siteID=${window.location.href.split('/').slice(-1)[0]}`
            : `/auth/query/list-client-site-access?uid=${auth?.id}`;

        axiosProtect.get(siteQueryURL).then(response => {
            const sites = response.data.sites || [];
            setSelectableSites(sites);
            setSelectedSiteNames(sites.map(site => site.name));
        }).catch(error => {
            setIsLoading(false);
            setErrorMessage(error.response?.data?.error || error.response?.data || 'Unable to load sites');
        });
    }, []);

    useEffect(() => {
        if(selectableSites.length === 0) return;
        if(selectedSiteNames.length === 0){
            setGraphData(null);
            setIsLoading(false);
            setErrorMessage('Select at least one site');
            return;
        }

        const selected = selectableSites.filter(site => selectedSiteNames.includes(site.name));
        setIsLoading(true);
        axiosProtect.get(`/tg/targets/emissions-graphs?sites=${selected.map(site => site.id).join(',')}`).then(response => {
            setGraphData(response.data.graphData?.consolidated || null);
            setErrorMessage('');
        }).catch(error => {
            setGraphData(null);
            setErrorMessage(error.response?.data?.error || error.response?.data || 'Unable to generate graph');
        }).finally(() => setIsLoading(false));
    }, [selectableSites, selectedSiteNames]);

    const selectedParameter = PARAMETER_OPTIONS.find(option => option.value === parameter);
    const data = graphData?.[parameter] || [];
    const allSelected = selectableSites.length > 0 && selectedSiteNames.length === selectableSites.length;

    const handleSiteSelection = event => {
        const value = event.target.value;
        if(value.includes('__all__')){
            setSelectedSiteNames(allSelected ? [] : selectableSites.map(site => site.name));
            return;
        }
        setSelectedSiteNames(typeof value === 'string' ? value.split(',') : value);
    };

    return (
        <div className="w-full">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                <IconButton className="et-carbon-one-icon-btn">
                    <a href="https://cloud.carbon-one.ca/company-dashboard" target="_blank" rel="noreferrer" className="et-carbon-one-link">
                        <img src={carbonOne} alt="Carbon One" className="et-carbon-one-logo"/>
                    </a>
                </IconButton>
            </div>

            <div style={{display: 'flex', flexDirection: props.isMobile || isMobile ? 'column' : 'row', alignItems: 'center'}}>
                <FormControl sx={{m: 1, flex: 2, width: props.isMobile || isMobile ? '100%' : 'auto'}}>
                    <InputLabel id="emission-sites-label">Sites</InputLabel>
                    <Select
                        labelId="emission-sites-label"
                        multiple
                        value={selectedSiteNames}
                        onChange={handleSiteSelection}
                        input={<OutlinedInput label="Sites" />}
                        renderValue={selected => selected.join(', ')}
                    >
                        <MenuItem value="__all__">
                            <Checkbox checked={allSelected}/>
                            <ListItemText primary="Select all"/>
                        </MenuItem>
                        {selectableSites.map(site => (
                            <MenuItem key={site.id} value={site.name}>
                                <Checkbox checked={selectedSiteNames.includes(site.name)}/>
                                <ListItemText primary={site.name}/>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl sx={{m: 1, flex: 1, width: props.isMobile || isMobile ? '100%' : 'auto'}}>
                    <InputLabel id="emission-parameter-label">Parameter</InputLabel>
                    <Select
                        labelId="emission-parameter-label"
                        value={parameter}
                        onChange={event => setParameter(event.target.value)}
                        input={<OutlinedInput label="Parameter" />}
                    >
                        {PARAMETER_OPTIONS.map(option => (
                            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            {errorMessage !== '' && <Alert severity="error" variant="filled" sx={{m: 1}}>{errorMessage}</Alert>}

            <div style={{height: props.isMobile || isMobile ? '62vh' : '68vh', backgroundColor: 'white', borderRadius: '1%', boxShadow: '2px 6px 12px rgb(164, 164, 164)', padding: '1%'}}>
                {isLoading ? (
                    <Box sx={{display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center'}}>
                        <CircularProgress/>
                    </Box>
                ) : (
                    <EmissionTrendGraph
                        title={selectedParameter.title}
                        data={data}
                        parameter={parameter}
                        isFinancial={parameter === 'financialSavings'}
                        yAxisLabel={selectedParameter.units}
                        isMobile={props.isMobile || isMobile}
                    />
                )}
            </div>
        </div>
    );
};

// export default LegacyEmissionTrends;
export default ConsolidatedEmissionTrends;
